import { connect } from 'react-redux';
import LunchBreak from '../../../components/DailyPlanning/LunchBreak/LunchBreak';
import { updateLunchBreak } from '../../../actions/entities/lunchBreaks';
import { refreshScheduler, getTravelTimesByPostcode } from '../../../actions/areas/dailyPlanning';

const mapDispatchToProps = dispatch => ({
  updateLunchBreak: data => dispatch(updateLunchBreak(data)),
  refreshScheduler: () => dispatch(refreshScheduler()),
  getTravelTimesByPostcode: postcode => dispatch(getTravelTimesByPostcode(postcode)),
});

const LunchBreakContainer = connect(
  null,
  mapDispatchToProps,
)(LunchBreak);

export default LunchBreakContainer;
